import Header from 'src/components/common/Header'
import Sidebar from 'src/components/Individual/common/Sidebar'

const Layout = () => {
  return (
    <div>
      <Header data-test='header' />
      <div className={'flex-column m-0'}>
        <Sidebar option={0} />
      </div>
    </div>
  )
}

export default Layout
